<template>
    <div class="fertilization-type-select">
        <select v-model="type" name="type">
            <option value="icsi">{{ $translate('icsi') }}</option>
            <option value="ivf">{{ $translate('ivf') }}</option>
            <option value="pimsi">{{ $translate('pimsi') }}</option>
            <option value="imsi">{{ $translate('imsi') }}</option>
            <option value="picsi">{{ $translate('picsi') }}</option>
            <option value="na">{{ $translate('na') }}</option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'FertilizationTypeSelect',
    props: {
        defaultType: {
            type: String,
            required: true
        }
    },
    data: () => ({
        type: 'na'
    }),
    watch: {
        defaultType: {
            immediate: true,
            handler(newDefaultType) {
                this.type = newDefaultType
            }
        },
        type(newType) {
            this.$emit('change', newType)
        }
    }
}
</script>

<style lang="scss" scoped>
.fertilization-type-select {
    height: 40px;
    border-radius: 4px;
    padding: 5px 10px;
    display: flex;
    align-items: center;

    @media screen {
        border: solid 1px $light;
    }

    @media print {
        justify-items: center;
    }

    select {
        background-color: transparent;
        border: none;
        width: 100%;

        @media screen {
            color: $light-3;
        }
        @media print {
            appearance: none;
            text-align: center;
            font-weight: 600;
        }

        option {
            background-color: $dark-4;
        }
    }
}
</style>
